<template>
	<div
		:class="$style['skeleton-rectangle']"
		:style="styles"
	/>
</template>

<script>
export default {
	name: 'SkeletonRectangle',
	props: {
		height: {
			type: String,
			default: '200px'
		},
		width: {
			type: String,
			default: '100%'
		},
		custom: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		styles () {
			const styles = {}
			styles.height = this.height
			styles.width = this.width

			return { ...styles, ...this.custom }
		}
	}
}
</script>

<style lang="scss" module>
	$from: getColorStatic(border-image);
	$to: scale-color($from, $lightness: -10%);

	.skeleton-rectangle {
		display: flex;
		height: 200px;
		width: 100%;
		border-radius: 5px;
		background-color: getColor(chip-light);
		will-change: opacity;
		animation: pulse 1.2s ease-in-out infinite;

		@keyframes pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.5; }
		}
	}
</style>
